/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.2.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * User dismisses the Firefox install-mobile promo banner (shown to users
 * already on Firefox) in the settings page.
 *
 * Generated from `firefox_promo.connect_mobile_dismiss`.
 */
export const connectMobileDismiss = new EventMetricType<{
  mobile_device_count?: string;
}>(
  {
    category: 'firefox_promo',
    name: 'connect_mobile_dismiss',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['mobile_device_count']
);

/**
 * User clicks the CTA on the Firefox install-mobile promo banner (shown to
 * users already on Firefox) in the settings page.
 *
 * Generated from `firefox_promo.connect_mobile_submit`.
 */
export const connectMobileSubmit = new EventMetricType<{
  mobile_device_count?: string;
}>(
  {
    category: 'firefox_promo',
    name: 'connect_mobile_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['mobile_device_count']
);

/**
 * User sees the Firefox promo banner encouraging them to install Firefox
 * on mobile (shown to users already on Firefox) in the settings page.
 *
 * Generated from `firefox_promo.connect_mobile_view`.
 */
export const connectMobileView = new EventMetricType<{
  mobile_device_count?: string;
}>(
  {
    category: 'firefox_promo',
    name: 'connect_mobile_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['mobile_device_count']
);

/**
 * User dismisses the Firefox switch promo banner (shown to users on a
 * non-Firefox browser) in the settings page.
 *
 * Generated from `firefox_promo.switch_to_firefox_dismiss`.
 */
export const switchToFirefoxDismiss = new EventMetricType<{
  mobile_device_count?: string;
}>(
  {
    category: 'firefox_promo',
    name: 'switch_to_firefox_dismiss',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['mobile_device_count']
);

/**
 * User clicks the CTA on the Firefox switch promo banner (shown to users on
 * a non-Firefox browser) in the settings page.
 *
 * Generated from `firefox_promo.switch_to_firefox_submit`.
 */
export const switchToFirefoxSubmit = new EventMetricType<{
  mobile_device_count?: string;
}>(
  {
    category: 'firefox_promo',
    name: 'switch_to_firefox_submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['mobile_device_count']
);

/**
 * User sees the Firefox promo banner encouraging them to switch to Firefox
 * (shown to users on a non-Firefox browser) in the settings page.
 *
 * Generated from `firefox_promo.switch_to_firefox_view`.
 */
export const switchToFirefoxView = new EventMetricType<{
  mobile_device_count?: string;
}>(
  {
    category: 'firefox_promo',
    name: 'switch_to_firefox_view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['mobile_device_count']
);
